import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import {
  ValidCaptcha,
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validaNumeroTelefono,
  validaEmail,
  validaDecimal,
  formatoDeci,
} from "../../util/varios";
import axios from "axios";

export const ClasificadorMultas = (props) => {
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [municipios, setMunicipios] = useState();
  const [impuestos, setImpuestos] = useState();
  const [ingresos, setIngresos] = useState();
  const [values, setValues] = useState({
    codigomulta: "",
    descripcion: "",
    factorcalculo: 1,
    idtipomulta: "",
    tipoimpuesto: "",
    idtipoingreso: "",
    valor: "",
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const txtAlicuota = useRef();
  const txtMinimo = useRef();
  const txtId = useRef();
  const txtDescrip = useRef();
  const txtCodigo = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const chkBs = useRef();
  const chkUt = useRef();
  const chkPetro = useRef();
  const chkUc = useRef();
  const cmbImuesto = useRef();
  const cmbIngreso = useRef();

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/multas/actualizarclases`;
    let body;
    setActivate(true);

    body = {
      operacion: operacion,
      nid: values.idtipomulta !== "" ? parseInt(values.idtipomulta) : 0,
      cod: values.codigomulta.trim(),
      descr: values.descripcion,
      val: parseFloat(
        txtMinimo.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      faccal: parseInt(values.factorcalculo),
      tipimp: values.tipoimpuesto.trim(),
      tipingre: values.idtipoingreso,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SeleccionarImpuestos = () => {
    setActivate(true);

    let campos = "idtipoimpuesto, descripcion";
    let nomtab = "tipoimpuesto";
    let condi = "idtipoimpuesto <= 4 ";
    let orden = "idtipoimpuesto";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setImpuestos(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarIngresos = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "tipoingreso";
    let condi = "true = true ";
    let orden = "idtipoingreso";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setIngresos(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChange = (event) => {
    if (
      event.target.name === "codigoclaseminas" ||
      event.target.name === "descripcion" ||
      event.target.name === "codigomulta"
    ) {
      event.target.value = event.target.value.toUpperCase();
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipoimpuesto") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "idtipoingreso") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "factorcalculo") {
      setValues({
        ...values,
        [event.target.name]: parseInt(event.target.value),
      });
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.which === 13) {
        if (event.target.id === "alicuotas") {
          txtAlicuota.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (values.codigomulta === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Código de la multa",
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (values.tipoimpuesto === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el tipo de Impuesto",
        icono: "informacion",
      });
      sigue = false;
      cmbImuesto.current.focus();
    } else if (values.idtipoingreso === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el tipo de Ingreso",
        icono: "informacion",
      });
      sigue = false;
      cmbIngreso.current.focus();
    } else if (values.descripcion === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa el Nombre del Clasificador",
        icono: "informacion",
      });
      sigue = false;
      txtDescrip.current.focus();
    } else if (txtMinimo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el valor de la multa",
        icono: "informacion",
      });
      sigue = false;
      txtMinimo.current.focus();
    } else if (
      !chkBs.current.checked &&
      !chkUt.current.checked &&
      !chkPetro.current.checked &&
      !chkUc.current.checked
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el factor calculo",
        icono: "informacion",
      });
      sigue = false;
      chkBs.current.focus();
    } else if (sigue) {
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const blanquear = () => {
    setActivate(false);
    setValues({
      codigomulta: "",
      descripcion: "",
      factorcalculo: 1,
      idtipomulta: "",
      tipoimpuesto: "",
      tipoiingreso: "",
      valor: "",
    });
    setOperacion(0);
  };

  const handleCloseSi = () => {
    Actualizar();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        SeleccionarImpuestos();
        SeleccionarIngresos();

        btnAcepta.current.focus();
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.claseMulta);
          if (props.claseMulta.factorcalculo === 1) {
            chkBs.current.checked = true;
          } else if (props.claseMulta.factorcalculo === 2) {
            chkPetro.current.checked = true;
          } else if (props.claseMulta.factorcalculo === 3) {
            chkUt.current.checked = true;
          } else if (props.claseMulta.factorcalculo === 4) {
            chkUc.current.checked = true;
          }
        } else {
          chkBs.current.checked = true;
          setValues({
            codigomulta: "",
            descripcion: "",
            factorcalculo: 1,
            idtipomulta: "",
            tipoimpuesto: "",
            idtipoingreso: "",
            valor: "",
          });
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {props.operacion === 1
              ? "Agregar Clasificador de Multas."
              : props.operacion === 2
              ? "Editar Clasificador de Multas."
              : props.operacion === 3
              ? "Eliminar Clasificador de Multas."
              : "Consultar Clasificador de Multas."}
          </h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div style={{ height: "auto", overflow: "auto" }}>
          <div>
            <div className="row rounded mx-auto">
              <div className="container rounded row  border  mx-auto col-md-12">
                <div className=" col-md-12 row py-3 px-2 d-flex justify-content-between mx-auto">
                  <div className="input-group input-group-sm col-sm-4 mb-2">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee" }}
                      id="inputGroup-sizing-sm"
                    >
                      Código:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      disabled={true}
                      name="idclaseminas"
                      ref={txtId}
                      value={values.idtipomulta}
                    />
                  </div>

                  <div className="input-group input-group-sm col-sm-6 mb-2">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee" }}
                      id="inputGroup-sizing-sm"
                    >
                      Código Multa:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtCodigo}
                      disabled={
                        operacion === 4 || operacion === 3 ? true : false
                      }
                      defaultValue={
                        values
                          ? values.codigomulta !== null
                            ? values.codigomulta.trim()
                            : ""
                          : ""
                      }
                      name="codigomulta"
                      onChange={onChange}
                      id="inputFechaInscripcion"
                    />
                  </div>

                  <div className="input-group input-group-sm col-sm-12 mb-2 ">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee" }}
                      id="inputGroup-sizing-sm"
                    >
                      Tipo de Impuesto:
                    </label>
                    <select
                      className="form-select form-select-sm"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : false
                      }
                      ref={cmbImuesto}
                      value={
                        values && values.tipoimpuesto !== ""
                          ? values.tipoimpuesto.trim()
                          : ""
                      }
                      id="inputStatus"
                      name="tipoimpuesto"
                      onChange={onChange}
                    >
                      <option value="">Seleccione</option>
                      {impuestos &&
                        impuestos.map((item, index) => (
                          <option key={index} value={item.idtipoimpuesto}>
                            {" "}
                            {item.descripcion.trim()}{" "}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group input-group-sm col-sm-12 mb-2 ">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee" }}
                      id="inputGroup-sizing-sm"
                    >
                      Tipo de Ingreso:
                    </label>
                    <select
                      className="form-select form-select-sm"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : false
                      }
                      ref={cmbIngreso}
                      value={
                        values && values.idtipoingreso !== ""
                          ? values.idtipoingreso
                          : ""
                      }
                      id="inputStatus"
                      name="idtipoingreso"
                      onChange={onChange}
                    >
                      <option value="">Seleccione</option>
                      {ingresos &&
                        ingresos.map((item, index) => (
                          <option key={index} value={item.idtipoingreso}>
                            {" "}
                            {item.descripcion.trim()}{" "}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group input-group-sm col-sm-12 mb-2">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee" }}
                      id="inputGroup-sizing-sm"
                    >
                      Descripción:
                    </label>

                    <textarea
                      class="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : false
                      }
                      defaultValue={
                        values
                          ? values.descripcion !== null
                            ? values.descripcion.trim()
                            : ""
                          : ""
                      }
                      rows={2}
                      onChange={onChange}
                      ref={txtDescrip}
                      name="descripcion"
                      style={{ height: "50px" }}
                      id="floatingTextarea"
                    />
                  </div>

                  <div className="input-group input-group-sm col-sm-5 mb-2">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "#55acee" }}
                      id="inputGroup-sizing-sm"
                    >
                      Valor Multa:
                    </label>
                    <input
                      type="text"
                      className="form-control text-right"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : false
                      }
                      maxLength="10"
                      name="minimo"
                      id="alicuota"
                      ref={txtMinimo}
                      defaultValue={
                        values
                          ? values.valor !== null
                            ? formatMoneda(
                                values.valor.replace(",", "").replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            : "0,00"
                          : "0,00"
                      }
                      onBlur={handleInputMontoChange}
                      onKeyUp={handleInputMontoChange}
                    />
                  </div>

                  <div className="col-md-12 mx-auto">
                    <fieldset className="col-sm-12 mx-auto row border rounded">
                      <legend
                        className="float-none w-auto"
                        style={{ fontSize: "15px" }}
                      >
                        Factor Calculo
                      </legend>

                      <div class="form-check col align-items-center pl-5">
                        <input
                          class="form-check-input"
                          ref={chkBs}
                          disabled={
                            operacion === 4 || operacion === 3 ? true : false
                          }
                          type="radio"
                          name="factorcalculo"
                          value={1}
                          onChange={onChange}
                          id="flexRadioDefault1"
                        />
                        <label
                          class="form-check-label py-1"
                          for="flexRadioDefault1"
                        >
                          Bolivares.
                        </label>
                      </div>
                      <div class="form-check col align-items-center ">
                        <input
                          class="form-check-input"
                          ref={chkPetro}
                          disabled={
                            operacion === 4 || operacion === 3 ? true : false
                          }
                          type="radio"
                          name="factorcalculo"
                          value={2}
                          onChange={onChange}
                          id="flexRadioDefault1"
                        />
                        <label
                          class="form-check-label py-1"
                          for="flexRadioDefault1"
                        >
                          Petro.
                        </label>
                      </div>
                      <div class="form-check col-md-3 px-0 align-items-center">
                        <input
                          class="form-check-input"
                          ref={chkUt}
                          disabled={
                            operacion === 4 || operacion === 3 ? true : false
                          }
                          type="radio"
                          name="factorcalculo"
                          value={3}
                          onChange={onChange}
                          id="flexRadioDefault1"
                        />
                        <label
                          class="form-check-label py-1"
                          for="flexRadioDefault1"
                        >
                          U. Tributaria.
                        </label>
                      </div>

                      <div class="form-check col-md-3 align-items-center">
                        <input
                          class="form-check-input"
                          ref={chkUc}
                          disabled={
                            operacion === 4 || operacion === 3 ? true : false
                          }
                          type="radio"
                          name="factorcalculo"
                          value={4}
                          onChange={onChange}
                          id="flexRadioDefault1"
                        />
                        <label
                          class="form-check-label py-1"
                          for="flexRadioDefault1"
                        >
                          U. Contable.
                        </label>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success "
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill "
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/multas/modalClasificadorMultas.js